// extracted by mini-css-extract-plugin
export default {"cls1":"D2DP5A2Zu1h3KqbUpFft","cls2":"G7TsgT7iM80JvvlEX1Cx D2DP5A2Zu1h3KqbUpFft","isPhone":"OtzIEZYXPfZZPXa3qf9H"};